/**
 * What a row shows where its translation would be (日本-102, frame `1a`).
 *
 * Four states, and the rule between them is the feature's governing claim expressed as a function:
 * **translation is never automatic**, so an untranslated row you are not looking at offers
 * nothing at all. A button on every line would turn a page of reading into a page of buttons.
 *
 * Pure and here rather than inside `Translation.tsx` because `npm test` has no DOM — a rule that
 * lives only in JSX is a rule nothing can assert.
 */
export type TranslationState =
  /** A request is out. `translating…` and the two-tone bar. */
  | "translating"
  /** There is English to read. The focused row also gets `edit · retranslate · remove`. */
  | "translated"
  /** The ghost `訳 translate` + `T`. **Focused row only, and only where it could work.** */
  | "offer"
  /** Nothing at all. */
  | "bare";

export function translationState(
  entry: { translation: string; translating: boolean },
  focused: boolean,
  configured: boolean,
): TranslationState {
  // **In flight wins over everything, including an existing translation.** `retranslate` on a row
  // that already has English must show that a request is out; falling through to `translated`
  // would leave the button looking dead for the second it takes.
  if (entry.translating) return "translating";
  if (entry.translation) return "translated";
  // An unconfigured deployment draws no affordance rather than one that always fails — and the `T`
  // key is gated on the same answer, so the key and the button cannot disagree.
  return focused && configured ? "offer" : "bare";
}
